{
  "$id": "wealthlane://forms/grant-management/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "grant_plan_header",
      "title": "",
      "fields": [
        {
          "type": "stack",
          "minCols": 2,
          "maxCols": 3,
          "minWidthPx": 320,
          "maxWidthPx": 720,
          "gap": 20,
          "style": {
            "flexDirection": "row",
            "alignItems": "center",
            "alignSelf": "start",
            "paddingBottom": 0
          },
          "stackFields": [
            { "scope": "#/properties/planName" },
            { "scope": "#/properties/uniquePlanNo" }
          ]
        }
      ]
    },
    {
      "rowId": "grant_details",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/grantName",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 400,
          "startNewRow": true
        },
        {
          "scope": "#/properties/planId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 400,
          "startNewRow": true
        },
        {
          "scope": "#/properties/planTypeName",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 400
        },
        {
          "scope": "#/properties/approvedDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 400,
          "startNewRow": true
        },
        {
          "scope": "#/properties/approvalRequired",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 400,
          "style": { "--ui-checkbox-label-size": "13px", "--ui-checkbox-label-lh": "1.4" }
        },
        {
          "scope": "#/properties/poolId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 400,
          "startNewRow": true
        },
        {
          "scope": "#/properties/acceptanceMethodId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 400
        },
        {
          "scope": "#/properties/settlementTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 400,
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "performance_rule_section",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/performanceRuleName",
          "minCols": 1,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 635,
          "startNewRow": true
        },
        {
          "type": "action-button",
          "actionId": "VIEW_GRANT_PERFORMANCE_RULE",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 100,
          "maxWidthPx": 140
        },
        {
          "type": "action-button",
          "actionId": "OPEN_PERFORMANCE_RULES_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "vesting_template_section",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/vestingTemplateName",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 635,
          "startNewRow": true
        },
        {
          "type": "action-button",
          "actionId": "OPEN_VESTING_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "grant_acceptance_template_section",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/grantAcceptanceTemplateId",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 635,
          "startNewRow": true
        },
        {
          "type": "action-button",
          "actionId": "OPEN_GRANT_ACCEPTANCE_TEMPLATE_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "grant_agreement_section",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/grantAgreementDocumentName",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 635
        },
        {
          "scope": "#/properties/grantAgreementDocs",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 800,
          "hideLabel": true,
          "startNewRow": true
        },
        {
          "type": "action-button",
          "actionId": "OPEN_GRANT_AGREEMENT_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "grant_notice_section",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/grantNoticeDocumentName",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 635
        },
        {
          "scope": "#/properties/grantNoticeDocs",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 800,
          "hideLabel": true,
          "startNewRow": true
        },
        {
          "type": "action-button",
          "actionId": "OPEN_GRANT_NOTICE_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "terms_conditions_section",
      "title": "Terms & Condition",
      "fields": [
        {
          "scope": "#/properties/agreementStatement",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 600
        },
        {
          "scope": "#/properties/agreementStatementStatusName",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 340
        },
        {
          "scope": "#/properties/enableTermsConditionText",
          "minCols": 1,
          "maxCols": 2,
          "minWidthPx": 250,
          "maxWidthPx": 400,
          "startNewRow": true,
          "style": { "alignSelf": "center" }
        },
        {
          "scope": "#/properties/termsAndConditionDocumentName",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 635,
          "startNewRow": true
        },
        {
          "scope": "#/properties/termsConditionDocDocs",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 800,
          "hideLabel": true,
          "startNewRow": true
        },
        {
          "type": "action-button",
          "actionId": "OPEN_TERMS_CONDITIONS_DOC_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        },
        {
          "scope": "#/properties/termsAndConditionTextName",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 635,
          "startNewRow": true
        },
        {
          "scope": "#/properties/termsConditionTextDocs",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 800,
          "hideLabel": true,
          "startNewRow": true
        },
        {
          "type": "action-button",
          "actionId": "OPEN_TERMS_CONDITIONS_TEXT_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        }
      ]
    }
  ]
}
